export default __webpack_public_path__ + "static/main-1-f2dc384de527b3316a53a1acc0fc350a.png";